var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { PureComponent } from "react";
import styled from "styled-components";
import noCardsLogo from "@irati/ui/images/saved-cards-empty.png";
import Card from "@irati/ui/src/Layout/Card";
import { injectIntl } from "@irati/utils/lang";
import id from "@irati/utils/id";
import { StyledLabel1, Inner } from "./styled";
var NoData = /** @class */ (function (_super) {
    __extends(NoData, _super);
    function NoData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoData.prototype.render = function () {
        var idNamespace = id("no-data", this.props);
        var _a = this.props, useCardStyle = _a.useCardStyle, text = _a.text, children = _a.children, formatMessage = _a.formatMessage;
        var Wrapper = useCardStyle ? Card : styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
        return (React.createElement(Wrapper, { id: idNamespace },
            React.createElement(Inner, null,
                React.createElement("img", { src: noCardsLogo, alt: formatMessage({ id: "wallet.noData.alt" }) }),
                React.createElement(StyledLabel1, null, text),
                children)));
    };
    NoData.defaultProps = {
        useCardStyle: false
    };
    return NoData;
}(PureComponent));
export default injectIntl(NoData);
var templateObject_1;
